import { DbMongoBaseInfos } from "./db-mongo-base-infos";
import { BillingAckSettings } from "./billing-ack-settings";
import { ExternalLinks } from "./external-links";
import { SpockAgentType } from "./spock-agent-type";
import { PlatformMode } from "./platform-mode";
import { Licences } from "./licences";
import { SignalrEventServer } from "./signalr-event-server";
import { TransferSettings } from "./transfer-settings";
import { YoutubeChannel } from "./youtube-channel";
import { AuthMode } from "./auth-mode";
import { AuthLDAPSettings } from "./auth-ldap-settings";
import { AuthADFSSettings } from "./auth-adfs-settings";
import { SettingPath } from "./setting-path";
import { PlatformDocument } from "./platform-document";
import { immerable } from "immer";
import { AuthOKTASettings } from "./auth-okta-settings";
import { PlanningView } from "./planning-view";
import { PlanningMode } from "./planning-mode";
import { CurrencyTypes } from "./currency-types";
import { YoutubeSettings } from "./youtube-settings";

export class BillingData {
  [immerable] = true;
  offerId: number = 0;
  currency: CurrencyTypes = CurrencyTypes.EUR;
  vat: number = 20;
  // Partial Billing Data
}

export class PlatformDcpSettings {
  [immerable] = true;
  groupVersionFile: boolean = false;
}

export class DbPlatformInfos extends DbMongoBaseInfos {
  [immerable] = true;
  name: string | null = null;
  brandName: string | null = null;
  urlBase: string | null = null;
  urlBaseApi: string | null = null;
  languageRefDataFieldTagName: string | null = null;
  territoryRefDataFieldTagName: string | null = null;
  loginSuffix: string | null = null;
  customerExternalIdLabel: string | null = null;
  brandLogoUrl: string | null = null;
  sidebarLogoUrl: string | null = null;
  faviconUrl: string | null = null;
  fontName: string | null = null;
  rightDealsMatchStartDateDaysDelay: number | null = 0;
  glossaryTitlePrefix: string | null = null;
  billingAckSettings: BillingAckSettings | null = null;
  externalLinks: ExternalLinks[] | null = null;
  spockAgentType: SpockAgentType | null = null;
  mode: PlatformMode | null = null;
  wowzaDocRootPath: string | null = null;
  wowzaPublicBaseUrl: string | null = null;
  wowzaServiceName: string | null = null;
  wowzaTokenSecretKey: string | null = null;
  ownerAddress: string | null = null;
  ownerZipCode: string | null = null;
  ownerCity: string | null = null;
  ownerPhone: string | null = null;
  ownerMasterEmail: string | null = null;
  invoiceRemarks: string | null = null;
  invoiceSupportEmails: string[] | null = null;
  asperaFaspexServerHost: string | null = null;
  asperaFaspexServerPort: number | null = 0;
  asperaFaspexServerUser: string | null = null;
  asperaFaspexServerPassword: string | null = null;
  asperaFaspexConnectFolderDocRootPath: string | null = null;
  asperaFaspexConnectMaxKeepingFileDays: number | null = 0;
  asperaEnterpriseServerHost: string | null = null;
  asperaEnterpriseServerPort: number | null = 0;
  asperaEnterpriseServerUser: string | null = null;
  asperaEnterpriseServerPassword: string | null = null;
  asperaEnterpriseServerAccountPrefix: string | null = null;
  asperaEnterpriseServerLogonUser: string | null = null;
  asperaEnterpriseServerLogonPassword: string | null = null;
  asperaEnterpriseServerUnderUnix: boolean | null = null;
  asperaEnterpriseServerDocRootPath: string | null = null;
  connectLogin: string | null = null;
  connectPassword: string | null = null;
  licences: Licences[] | null = [];
  erpApiLogin: string | null = null;
  erpApiPassword: string | null = null;
  kafkaServerUrl: string | null = null;
  kafkaTopics: { [key: string]: string } | null = null;
  authotToken: string | null = null;
  eventNotifierServers: SignalrEventServer[] | null = [];
  transferSettings: TransferSettings | null = null;
  youtubeSettings: YoutubeChannel[] | null = null;
  authMode: AuthMode | null = null;
  ldapSettings: AuthLDAPSettings | null = null;
  adfsSettings: AuthADFSSettings | null = null;
  oktaSettings: AuthOKTASettings | null = null;
  fileAttachmentsPath: SettingPath | null = null;
  documents: PlatformDocument[] | null = null;
  exportIncludeDisabledOrGenerated: boolean | null = null;
  watermarkForceDelayDays: number = 0;
  maxShareViewDays: number | null = 0;
  maxShareViews: number | null = 0;
  maxShareViewIPs: number | null = 0;
  maxShareViewClipsNumber: number | null = 0;
  maxShareViewClipsDuration: string | null = null;
  defaultShareViewDays: number | null = 0;
  defaultShareViews: number | null = 0;
  defaultShareViewIPs: number | null = 0;
  defaultShareViewClipsNumber: number | null = 0;
  defaultShareViewClipsDuration: string | null = null;
  defaultShareName: string | null = null;
  catchPhrase: string | null = null;
  defaultPlanningView: PlanningView | null = null;
  defaultPlanningMode: PlanningMode | null = null;
  defaulPlanningTaskDuration: string | null = null;
  archiveDisable: boolean = false;
  billingData: BillingData | null = null;
  cof: boolean = false;
  wowzaUseHlsChunker: boolean = false;
  allowPlayRawAsRefIfNotMezzFound: boolean = false;
  ytSettings: YoutubeSettings | null = null;
  dcpSettings: PlatformDcpSettings | null = null;
  showUnassignedKdmRecipients: boolean | null = null;

  constructor(init?: Partial<DbPlatformInfos>) {
    super();
    Object.assign(this, init);
  }
}
